<template>
    <div>
        <div class="field is-expanded">
            <div class="field">
                <div class="control is-expanded">
                    <textarea
                        :value="embedCode"
                        :placeholder="$t('Object.embed_description')"
                        class="textarea has-fixed-size"
                        name="embed"
                        @input="$emit('input', $event.target.value)"
                    ></textarea>
                </div>
            </div>
            <p class="control">
                <button
                    v-t="'creation.preview'"
                    class="button is-outlined is-link"
                    @click="loadPreview"
                />
            </p>
        </div>
        <div v-if="showPreview" v-html="embedCode"></div>
    </div>
</template>

<script>
export default {
    name: 'InputEmbed',
    components: {},
    model: {
        prop: 'embedCode',
    },
    props: {
        embedCode: { type: String, default: undefined },
    },
    data() {
        return {
            loading: false,
            showPreview: false,
        };
    },
    computed: {},
    watch: {},
    methods: {
        loadPreview() {
            this.showPreview = true;
        },
    },
};
</script>

<style></style>
